var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1521 47.7255C37.3311 47.7255 48.0148 37.0418 48.0148 23.8627C48.0148 10.6837 37.3311 0 24.1521 0C10.9731 0 0.289337 10.6837 0.289337 23.8627C0.289337 37.0418 10.9731 47.7255 24.1521 47.7255Z",
    fill: "#8258A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M24.1521 11.4346L16.7515 18.1381C11.1306 23.0767 6.22166 27.9116 1.52029 32.7168C4.84239 41.5114 11.2641 47.1768 22.7728 47.6959L34.0739 36.3948V25.6276L36.8917 22.9581L31.5675 18.1381L24.1521 11.4346Z",
    fill: "url(#paint0_linear_0_1003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1521 11.4346L16.7515 18.1381L11.4124 22.9581H13.207L18.0863 18.5385L24.1521 13.0511L30.2179 18.5385L35.0972 22.9581H36.8918L31.5675 18.1381L24.1521 11.4346ZM24.1521 13.9706L19.1838 18.4644L14.2155 22.9581V36.3948H20.8152V25.9687H27.4742V36.3948H34.0739V22.9581L29.1056 18.4644L24.1521 13.9706ZM22.1203 27.3035V36.3948H26.1691V27.3035H22.1203Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1003",
    x1: 25.6463,
    y1: 25.9679,
    x2: 5.13145,
    y2: 48.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.7107,
    height: 47.7107,
    fill: "white",
    transform: "translate(0.289337)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.18947c04cf9fecc0c33a7a4abc4b9ac1.svg";
export { ForwardRef as ReactComponent };